'use strict';

var UserLandingConfig = function UserLandingConfig($stateProvider) {
  $stateProvider.state('app.user-landing', {
    url: '/workflow/user-landing',
    params: {
      transitionData: null
    },
    views: {
      '': {
        template: require('../templates/user-landing-panel.html')
      }
    }
  });
};
UserLandingConfig.$inject = ['$stateProvider'];
module.exports = UserLandingConfig;